<template>
  <div class="app-container">
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount } from 'vue'
import { useSystemConfigStoreHook } from '@/store/modules/systemConfig'
import { CommonUtils } from "@/utils/commonUtils";

const sysStore = useSystemConfigStoreHook()

onBeforeMount(async () => {
  // 2. 语言国际化：把当前语言写入 <html lang="...">
  // document.documentElement.setAttribute('lang', sysStore.currentLang)
  CommonUtils.applyTheme()
  // 4. Favicon 替换：把后端下发的 logoUrl 设为 favicon
  const logoUrl = sysStore.commonConfig.logoUrl
  if (logoUrl) {
    CommonUtils.changeFavicon(logoUrl)
  }
}) 
</script>

<style scoped>
.app-container {
  width: 100%;
  min-height: 100vh;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>